/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveStringsOperation
 */
export interface RemoveStringsOperation {
    /**
     * 
     * @type {Array<string>}
     * @memberof RemoveStringsOperation
     */
    values: Array<string>;
}

/**
 * Check if a given object implements the RemoveStringsOperation interface.
 */
export function instanceOfRemoveStringsOperation(value: object): value is RemoveStringsOperation {
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function RemoveStringsOperationFromJSON(json: any): RemoveStringsOperation {
    return RemoveStringsOperationFromJSONTyped(json, false);
}

export function RemoveStringsOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveStringsOperation {
    if (json == null) {
        return json;
    }
    return {
        
        'values': json['values'],
    };
}

export function RemoveStringsOperationToJSON(value?: RemoveStringsOperation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'values': value['values'],
    };
}

